import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withPagination } from '../../shared/store/pagination.feature';
import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { Cartographie } from '../models/cartographie.model';
import { avecMéthodesCartographie } from './cartographie.methods';
import { CartographieState, initialState } from './cartographie.state';
import { avecSélecteursCartographies } from './cartographie.selectors';

export const CartographieStore = signalStore(
  { providedIn: 'root' },
  withEntities<Cartographie>(),
  withState<CartographieState>(initialState),
  withSelectedEntity(),
  withPagination<Cartographie>(),
  avecMéthodesCartographie(),
  avecSélecteursCartographies(),
);
